const COLORS = {
  green: "#29642f",
  black: "black",
  white: "white",
};

export default COLORS;
